// extracted by mini-css-extract-plugin
export var actionButton = "_r0-0";
export var actionMenuContainer = "_r0-i";
export var bubble = "_r0-2";
export var bubbleActionMenu = "_r0-j";
export var bubbleContext = "_r0-6";
export var bubbleItems = "_r0-7";
export var customer = "_r0-3";
export var divider = "_r0-8";
export var fileList = "_r0-9";
export var hiddenComment = "_r0-o";
export var infoAbove = "_r0-a";
export var internal = "_r0-4";
export var lightActionButton = "_r0-1";
export var link = "_r0-b";
export var merchant = "_r0-5";
export var message = "_r0-c";
export var profilePicture = "_r0-e";
export var quillToolbarContainer = "_r0-f";
export var senderDate = "_r0-g";
export var senderDateCustomer = "_r0-h";
export var senderName = "_r0-d";
export var time = "_r0-k";
export var uploadedImage = "_r0-l";
export var username = "_r0-m";
export var xsmall = "_r0-n";